import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LoginPage, {
  Username,
  Submit,
  Title,
  Logo,
  Password
} from '@react-login-page/page5';
import  {SERVIDOR} from './../../config';
import axios from 'axios';



const LoginWithoutCaptcha = () => {
  const navigate = useNavigate();

  const [error, setError] = useState('');

  // Función principal de manejo del submit
  const handleSubmit = async (event) => {
    // Prevenir el comportamiento por defecto
    event.preventDefault();
    setError('');
    
    try {
      // Obtener el valor del token
      const formData = new FormData(event.target);
      const token = formData.get('userToken');

      if (!token) {
        setError('Please enter your token');
        return;
      }

      // Mostrar que el botón fue pulsado
      // console.log('BOTON PULSADO');
      // alert(token);

      // Simular el login
      // const response = await loginUser({ token });
      // console.log('Login successful:', response);

      // fetch(SERVIDOR+'/api/login-token/'+token, )
      // .then(response => response.json())
      // .then(data => {
      //   if(data.ok){
      //       // token correcto, podemos redirigir
      //       console.log('CORRECTO');
      //       alert('CORRECTO')
            
      //     }else if (data.status){
      //       // token vencido
      //       alert('TOKEN VENCIDO')
    
      //     }else {
      //       // no existe ningun token
      //       alert('TOKEN INVALIDO')
    
      //     }
      // })

      const response =  await axios.get(SERVIDOR+'/api/login-token/'+token, { withCredentials: true } )
      const data = response.data;

      if(data.ok){
              // token correcto, podemos redirigir
              console.log('CORRECTO');
              alert('CORRECTO')
              localStorage.setItem('accesToken', data.accesToken)
              

              setTimeout( () => navigate('/products/all'), 1000)
              // navigate('/products/all');
              
            }else if (data.status){
              // token vencido
              alert('TOKEN VENCIDO')
      
            }else {
              // no existe ningun token
              alert('TOKEN INVALIDO')
      
            }
      
      
    } catch (error) {
      console.error('Error during login:', error);
      setError('Error logging in. Please try again.');
    }
  };

 

  const loginUser = async (credentials) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true });
      }, 1000);
    });
  };

  return (
    <div className="w-full max-w-md mx-auto px-4 py-8 mt-8">
      <style>
        {`
          .login-page5 {
            --login-bg: #ffffff;
            --login-inner-bg: #739072;
            --login-color: #333;
            --login-btn-bg: #697565;
            --login-btn-hover: #56634e;
            --login-btn-focus: #454c3d;
            --login-btn-active: #3b4234;
          }

          .login-page5::before {
            background: linear-gradient(to right, #697565, #e6e6e6);
          }

          .login-input {
            background-color: white !important;
            border: 1px solid #ddd !important;
            margin-bottom: 4 !important;
            padding: 2 !important;
            width: full !important;
            display: block !important;
          }

          .login-button {
            width: full !important;
            padding: 2 !important;
            margin-top: 4 !important;
          }

          .login-page5 .login-page5-inner {
            display: flex !important;
            flex-direction: column !important;
            gap: 4 !important;
          }
        `}
      </style>

      <form onSubmit={handleSubmit}>
        <LoginPage>
          {error && (
            <div className="mb-4 text-red-500 text-sm">
              {error}
            </div>
          )}

          <div className="flex justify-center mb-6">
            <Username
              name="userToken"
              keyname="userToken"
              placeholder="Enter your token"
              className="text-center w-full border border-gray-300 p-3 rounded-lg text-lg"
              required
            />
          </div>

          <Submit 
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg"
          >
            Login
          </Submit>

          {/* Hide default username/password fields */}
          <Username visible={false} />
          <Password visible={false} />
          <Title visible={false} />
          <Logo visible={false} />
        </LoginPage>
      </form>
    </div>
  );
};

export default LoginWithoutCaptcha;